import { Link } from "react-router-dom"

import StarIcon from "../../../../components/icons/star-icon"

import { SIDO_COLOR_MAP } from "@/datas/apartData"

const AptLinkCard = ({ item, onToggleGroup, isEditMode = false, starColor, isPending = false }) => {
  const targetUrl = `/apt/${item.sido_key.toLocaleLowerCase()}/${item.kapt_code}/overview`
  const isLinkable = !!item.sido_key && !!item.kapt_code && !isEditMode
  const Container = isLinkable ? Link : "div"

  const handleStarClick = async (e) => {
    e.preventDefault()
    e.stopPropagation()

    if (isPending) return

    await onToggleGroup?.(item.kapt_code)
  }

  return (
    <Container
      to={isLinkable ? targetUrl : undefined}
      className={`
        group relative rounded-2xl border border-slate-100 bg-white p-5
        shadow-sm transition-all
        ${isLinkable ? "cursor-pointer hover:border-blue-300 hover:shadow-md" : "cursor-default"}
      `}
    >
      <button
        type="button"
        disabled={isPending}
        onClick={handleStarClick}
        className={`
          absolute right-4 top-4 z-10 rounded-full p-1.5
          transition-all hover:scale-110 hover:bg-slate-50
          focus-visible:outline-none focus-visible:ring-2
          focus-visible:ring-blue-400
          disabled:cursor-wait disabled:opacity-50
        `}
      >
        <span className={`block text-2xl transition-colors ${starColor}`}>
          <StarIcon />
        </span>
      </button>

      <div
        className="mb-2 text-[11px] font-black uppercase tracking-wider"
        style={{ color: SIDO_COLOR_MAP[item.sido_key] }}
      >
        ● {item.sido}
      </div>

      <h3
        className={`
          mb-1 pr-8 text-lg font-bold transition-colors
          ${isLinkable ? "group-hover:text-blue-600" : "text-slate-800"}
        `}
      >
        {item.apt_name}
      </h3>

      <p className="text-sm text-slate-400">{item.road_addr}</p>
    </Container>
  )
}

export default AptLinkCard
